/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { ProjectCatalogType } from '../interfaces/ProjectCatalogType';
import jsonSchema from './FirebaseSchema.json';
import { fancyConfig } from '../FancyConfig';
import { logger } from '@touchplan/logging';

export enum SupportedSchemaErrors {
	schemaNotFound = 'the required schema was not found in the data',
}

interface ISchemaDefinition {
	path: string;
	partitions: ProjectCatalogType[];
	key?: string;
	projectCatalogType?: ProjectCatalogType;
}

export class FancyFirebaseSchema {
	public getSchema(pathSegments: string[]): ISchemaDefinition {
		const dbSchema: { [key: string]: object } = jsonSchema;
		// Find schema depending on path
		let key = pathSegments[0];
		for (let i = 0; i < pathSegments.length - 1; i++) {
			if (dbSchema[key] !== undefined) {
				break;
			}
			key += '/' + pathSegments[i + 1];
		}
		if (dbSchema[key] === undefined) {
			//some additional contenxt when missing
			logger.log('missing path', key);
			throw new Error(SupportedSchemaErrors.schemaNotFound);
		}
		const schema = dbSchema[key] as ISchemaDefinition;

		// If we don't have project partitioning enabled, override to master
		let projectCatalogType = schema.partitions[0];
		if (!fancyConfig.enablePartitioning) {
			projectCatalogType = ProjectCatalogType.Master;
		}

		return {
			key,
			path: schema.path,
			partitions: schema.partitions,
			projectCatalogType,
		} as ISchemaDefinition;
	}
}

export const fancyFirebaseSchema: FancyFirebaseSchema = new FancyFirebaseSchema();
